import React,{useEffect,useRef} from "react";
import {PopupView as NativeComponent} from "vritra";
import ReactDOM from "react-dom/client";


export default function PopupView(props){
    const {containerRef,targetRef}=props;
    const state=useRef({
        element:null,
    }).current;
    useEffect(()=>{
        const container=containerRef?.current;
        state.element=NativeComponent({
            ...props,
            parent:container,
            target:targetRef?.current,
        });
        const component=ReactDOM.createRoot(state.element);
        component.render(props.children||[]);
        return ()=>{
            state.element?.unmount();
        }
    },[]);
    return React.createElement(React.Fragment);
}
